(function () {
  function closestParent(element, selector) {
    var node = element;
    while (node && node !== document) {
      if (node.matches && node.matches(selector)) {
        return node;
      }
      node = node.parentNode;
    }
    return null;
  }

  function triggerChange(element) {
    if (!element) {
      return;
    }

    element.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  }

  function parseVariants(section) {
    if (!section) {
      return [];
    }

    if (section._variantColumnsVariants) {
      return section._variantColumnsVariants;
    }

    var jsonNode = section.querySelector('[data-variant-json]');
    if (!jsonNode) {
      section._variantColumnsVariants = [];
      return section._variantColumnsVariants;
    }

    try {
      section._variantColumnsVariants = JSON.parse(jsonNode.textContent);
    } catch (error) {
      section._variantColumnsVariants = [];
    }

    return section._variantColumnsVariants;
  }

  function setOrRemoveAttribute(element, name, value) {
    if (!element) {
      return;
    }

    if (value === null || value === undefined || value === '') {
      element.removeAttribute(name);
      return;
    }

    element.setAttribute(name, value);
  }

  function blockSyncsMainImage(block) {
    return !!block && block.getAttribute('data-sync-main-image') === 'true';
  }

  function blockAllowsUncheck(block) {
    return !!block && block.getAttribute('data-allow-uncheck-variant') === 'true';
  }

  function getBlockDefaultUncheckVariantId(block) {
    if (!block) {
      return null;
    }

    var value = parseInt(block.getAttribute('data-default-uncheck-variant-id'), 10);
    if (!value || isNaN(value)) {
      return null;
    }

    return value;
  }

  function findCardByVariantId(block, variantId) {
    if (!block || !variantId) {
      return null;
    }

    return block.querySelector('[data-variant-card][data-variant-id="' + variantId + '"]');
  }

  function sectionHasMainImageSync(section) {
    return !!section && !!section.querySelector('[data-variant-columns-block][data-sync-main-image="true"]');
  }

  function readMainImageOverride(card) {
    if (!card) {
      return null;
    }

    var url = card.getAttribute('data-main-image-override-url');
    if (!url) {
      return null;
    }

    var width = parseInt(card.getAttribute('data-main-image-override-width'), 10);
    var height = parseInt(card.getAttribute('data-main-image-override-height'), 10);

    if (isNaN(width) || width < 1) {
      width = null;
    }

    if (isNaN(height) || height < 1) {
      height = null;
    }

    return {
      url: url,
      width: width,
      height: height,
      alt: card.getAttribute('data-main-image-override-alt') || ''
    };
  }

  function getCurrentMainImage(section) {
    if (!section) {
      return null;
    }

    var gallery = section.querySelector('[data-product-photos]');
    if (!gallery) {
      return null;
    }

    var selectors = [
      '.product-main-slide.is-selected .image-wrap:not(.hide) img:not([role="presentation"])',
      '.product-main-slide.starting-slide .image-wrap:not(.hide) img:not([role="presentation"])',
      '.product-main-slide.is-selected .image-wrap img:not([role="presentation"])',
      '.product-main-slide .image-wrap img:not([role="presentation"])'
    ];

    var index;
    for (index = 0; index < selectors.length; index += 1) {
      var image = gallery.querySelector(selectors[index]);
      if (image) {
        return image;
      }
    }

    return null;
  }

  function captureMainImageState(image) {
    if (!image) {
      return null;
    }

    var wrap = closestParent(image, '.image-wrap');

    return {
      image: image,
      wrap: wrap,
      wrapStyle: wrap ? wrap.getAttribute('style') : null,
      className: image.className,
      attrs: {
        src: image.getAttribute('src'),
        dataSrc: image.getAttribute('data-src'),
        srcset: image.getAttribute('srcset'),
        dataSrcset: image.getAttribute('data-srcset'),
        dataWidths: image.getAttribute('data-widths'),
        dataAspectratio: image.getAttribute('data-aspectratio'),
        dataSizes: image.getAttribute('data-sizes'),
        dataPhotoswipeSrc: image.getAttribute('data-photoswipe-src'),
        dataPhotoswipeWidth: image.getAttribute('data-photoswipe-width'),
        dataPhotoswipeHeight: image.getAttribute('data-photoswipe-height'),
        alt: image.getAttribute('alt')
      }
    };
  }

  function clearMainImageOverride(section) {
    if (!section || !section._variantColumnsMainImageState) {
      return;
    }

    var state = section._variantColumnsMainImageState;
    var image = state.image;
    if (!image) {
      section._variantColumnsMainImageState = null;
      return;
    }

    image.className = state.className || image.className;
    setOrRemoveAttribute(image, 'src', state.attrs.src);
    setOrRemoveAttribute(image, 'data-src', state.attrs.dataSrc);
    setOrRemoveAttribute(image, 'srcset', state.attrs.srcset);
    setOrRemoveAttribute(image, 'data-srcset', state.attrs.dataSrcset);
    setOrRemoveAttribute(image, 'data-widths', state.attrs.dataWidths);
    setOrRemoveAttribute(image, 'data-aspectratio', state.attrs.dataAspectratio);
    setOrRemoveAttribute(image, 'data-sizes', state.attrs.dataSizes);
    setOrRemoveAttribute(image, 'data-photoswipe-src', state.attrs.dataPhotoswipeSrc);
    setOrRemoveAttribute(image, 'data-photoswipe-width', state.attrs.dataPhotoswipeWidth);
    setOrRemoveAttribute(image, 'data-photoswipe-height', state.attrs.dataPhotoswipeHeight);
    setOrRemoveAttribute(image, 'alt', state.attrs.alt);

    if (state.wrap) {
      setOrRemoveAttribute(state.wrap, 'style', state.wrapStyle);
    }

    section._variantColumnsMainImageState = null;
  }

  function applyMainImageOverride(section, overrideData) {
    if (!section || !overrideData || !overrideData.url) {
      return;
    }

    var image = getCurrentMainImage(section);
    if (!image) {
      return;
    }

    clearMainImageOverride(section);
    var state = captureMainImageState(image);
    if (!state) {
      return;
    }

    section._variantColumnsMainImageState = state;

    image.classList.remove('lazyload');
    image.classList.remove('lazyloading');
    image.classList.add('lazyloaded');

    setOrRemoveAttribute(image, 'src', overrideData.url);
    setOrRemoveAttribute(image, 'data-src', overrideData.url);
    setOrRemoveAttribute(image, 'srcset', null);
    setOrRemoveAttribute(image, 'data-srcset', null);
    setOrRemoveAttribute(image, 'data-widths', null);
    setOrRemoveAttribute(image, 'data-aspectratio', null);
    setOrRemoveAttribute(image, 'data-sizes', 'auto');
    setOrRemoveAttribute(image, 'data-photoswipe-src', overrideData.url);

    if (overrideData.width && overrideData.height) {
      setOrRemoveAttribute(image, 'data-photoswipe-width', String(overrideData.width));
      setOrRemoveAttribute(image, 'data-photoswipe-height', String(overrideData.height));

      if (state.wrap) {
        var ratio = (overrideData.height / overrideData.width) * 100;
        state.wrap.style.height = '0';
        state.wrap.style.paddingBottom = ratio.toFixed(4) + '%';
      }
    }

    if (overrideData.alt) {
      setOrRemoveAttribute(image, 'alt', overrideData.alt);
    }
  }

  function syncMainImageFromCard(section, block, card) {
    if (!section || !block || !card || !blockSyncsMainImage(block)) {
      return;
    }

    var overrideData = readMainImageOverride(card);
    if (!overrideData || !overrideData.url) {
      clearMainImageOverride(section);
      return;
    }

    window.requestAnimationFrame(function () {
      applyMainImageOverride(section, overrideData);
    });
  }

  function setActiveCard(block, variantId) {
    if (!block || !variantId) {
      return;
    }

    var cards = block.querySelectorAll('[data-variant-card]');
    var index;

    for (index = 0; index < cards.length; index += 1) {
      var cardVariantId = parseInt(cards[index].getAttribute('data-variant-id'), 10);
      var isActive = cardVariantId === variantId;
      cards[index].classList.toggle('is-active', isActive);
      cards[index].setAttribute('aria-pressed', isActive ? 'true' : 'false');
    }
  }

  function selectVariantInSection(section, variantId) {
    if (!section || !variantId) {
      return false;
    }

    var variants = parseVariants(section);
    var targetVariant = null;
    var index;

    for (index = 0; index < variants.length; index += 1) {
      if (parseInt(variants[index].id, 10) === variantId) {
        targetVariant = variants[index];
        break;
      }
    }

    if (!targetVariant) {
      return false;
    }

    var optionControlsFound = false;
    var optionIndex;

    for (optionIndex = 1; optionIndex <= 3; optionIndex += 1) {
      var optionValue = targetVariant['option' + optionIndex];
      if (!optionValue) {
        continue;
      }

      var controls = section.querySelectorAll('[data-index="option' + optionIndex + '"]');
      if (!controls.length) {
        continue;
      }

      optionControlsFound = true;

      var controlIndex;
      for (controlIndex = 0; controlIndex < controls.length; controlIndex += 1) {
        var control = controls[controlIndex];

        if (control.tagName === 'SELECT') {
          if (control.value !== optionValue) {
            control.value = optionValue;
            triggerChange(control);
          }
          continue;
        }

        if ((control.type === 'radio' || control.type === 'checkbox') && control.value === optionValue && !control.checked) {
          control.checked = true;
          triggerChange(control);
        }
      }
    }

    var masterSelect = section.querySelector('select[data-product-select], select[name="id"]');
    if (masterSelect && String(masterSelect.value) !== String(variantId)) {
      masterSelect.value = String(variantId);
      triggerChange(masterSelect);
    }

    return optionControlsFound || !!masterSelect;
  }

  function syncBlocksInSection(section, variantId) {
    if (!section || !variantId) {
      return;
    }

    var blocks = section.querySelectorAll('[data-variant-columns-block]');
    var index;

    for (index = 0; index < blocks.length; index += 1) {
      setActiveCard(blocks[index], variantId);
    }
  }

  function setupSectionVariantListener(section) {
    if (!section || section._variantColumnsListenerReady === true) {
      return;
    }

    section._variantColumnsListenerReady = true;

    section.addEventListener('variantChange', function (event) {
      var detail = event && event.detail ? event.detail : {};
      var variant = detail.variant;
      if (!variant || !variant.id) {
        return;
      }

      if (sectionHasMainImageSync(section)) {
        clearMainImageOverride(section);
      }

      syncBlocksInSection(section, parseInt(variant.id, 10));
    });
  }

  function setupBlock(block) {
    if (!block || block.getAttribute('data-variant-columns-ready') === 'true') {
      return;
    }

    block.setAttribute('data-variant-columns-ready', 'true');

    var section = closestParent(block, '.product-section');
    setupSectionVariantListener(section);

    var cards = block.querySelectorAll('[data-variant-card]');
    var cardIndex;

    for (cardIndex = 0; cardIndex < cards.length; cardIndex += 1) {
      cards[cardIndex].addEventListener('click', function (event) {
        var card = event.currentTarget;
        var variantId = parseInt(card.getAttribute('data-variant-id'), 10);
        if (!variantId) {
          return;
        }

        var isActiveCard = card.classList.contains('is-active') || card.getAttribute('aria-pressed') === 'true';
        if (blockAllowsUncheck(block) && isActiveCard) {
          var fallbackVariantId = getBlockDefaultUncheckVariantId(block);
          if (fallbackVariantId && fallbackVariantId !== variantId) {
            setActiveCard(block, fallbackVariantId);

            var fallbackApplied = selectVariantInSection(section, fallbackVariantId);
            if (!fallbackApplied) {
              window.location.href = window.location.pathname + '?variant=' + fallbackVariantId;
              return;
            }

            var fallbackCard = findCardByVariantId(block, fallbackVariantId);
            if (fallbackCard) {
              syncMainImageFromCard(section, block, fallbackCard);
            } else if (blockSyncsMainImage(block)) {
              clearMainImageOverride(section);
            }
          }
          return;
        }

        setActiveCard(block, variantId);

        var applied = selectVariantInSection(section, variantId);
        if (!applied) {
          var fallbackUrl = card.getAttribute('data-variant-url');
          if (fallbackUrl) {
            window.location.href = fallbackUrl;
          }
          return;
        }

        syncMainImageFromCard(section, block, card);
      });
    }

    var initialActive = parseInt(block.getAttribute('data-active-variant-id'), 10);
    if (initialActive) {
      setActiveCard(block, initialActive);
    }
  }

  function initBlocks(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var blocks = root.querySelectorAll('[data-variant-columns-block]');
    var index;

    for (index = 0; index < blocks.length; index += 1) {
      setupBlock(blocks[index]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initBlocks(document);
    });
  } else {
    initBlocks(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initBlocks(event.target);
  });

  document.addEventListener('quickview:loaded', function () {
    initBlocks(document);
  });
})();
